module.exports = __webpack_public_path__ + "static/media/POVER_MENU-normal.83891eb7.png";